import { Component,QueryList,OnInit, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageDialogComponent } from '../image-dialog/image-dialog.component';
import * as moment from 'moment';


@Component({
  selector: 'app-qr-scan',
  templateUrl: './qr-scan.component.html',
  styleUrls: ['./qr-scan.component.scss']
})
export class QrScanComponent implements OnInit {
  visitorDetails: any;
  registraionDetail:any;
  @ViewChild('autofocus', { static: false }) textAreas: ElementRef;

  registraionNo = '';
  idType = ''; // 'registration', 'donation', or 'pujan'
  public onChangeSearch = new Subject<string>();
  public errorMsg = '';
  public successMsg = '';
  public loading = false;
  public env: any = environment;

  constructor(
  private appComponent: AppComponent,
  private apiService: ApiService,
  private modalService: NgbModal,
  ) { }

  ngOnInit() {
    this.onChangeSearch
    .pipe(debounceTime(1500))
    .subscribe(() => {
      this.registraionNo = this.registraionNo.trim();
      if(this.registraionNo){
        // Use split for all ID types
        if (this.registraionNo.includes('Registration ID : ')) {
          this.idType = 'registration';
          this.registraionNo = this.registraionNo.split('Registration ID : ')[1];
        } else if (this.registraionNo.includes('Donation ID:')) {
          this.idType = 'donation';
          // this.registraionNo = this.registraionNo.split('Donation ID:')[1];
        } else if (this.registraionNo.includes('Pujan ID:')) {
          this.idType = 'pujan';
          // this.registraionNo = this.registraionNo.split('Pujan ID:')[1];
        } else {
          this.idType = 'registration'; // Default to registration if no prefix
        }
        this.getVisitorDetail();
      }
    });
  }
  ngAfterViewInit(){
    this.textAreas.nativeElement.focus();
  }

  viewImage(imageUrl){
    const modalRef = this.modalService.open(ImageDialogComponent,
      {
        centered: false, size: 'md', windowClass: 'my-class', scrollable: false,
        backdrop: 'static', keyboard: false,
      });
    const imageDialogComponent: ImageDialogComponent = modalRef.componentInstance;
    imageDialogComponent.imageUrl = `${imageUrl}`;
  }


  getVisitorDetail(registraionNo?,element?){
    this.loading = true;
   
    this.errorMsg = '';
    if((this.registraionNo && this.registraionNo.length >= 8) || registraionNo) {
      let formObj : any = {
        reg_no : registraionNo ? registraionNo : this.registraionNo
      };
      
      // Determine API endpoint based on ID type
      let apiEndpoint = '/qr_code_scans'; // Default for registration
      if (this.idType === 'donation' || this.idType === 'pujan') {
        apiEndpoint = '/validate_qr_scans';
        formObj = {
          qr_code_text : this.registraionNo
        }
      }
      
     this.appComponent.showLoader();
     this.apiService.postDataToServer(apiEndpoint, formObj).subscribe(
       (res:any) => {
         if(registraionNo){
           element.verify = true
         } else{
          this.visitorDetails = res && res.data ? res.data : res;
         }
         this.appComponent.showMessageAlert(res['message'], 'success');
        this.appComponent.hideLoader();
        this.errorMsg = '';
        this.loading = false;
        this.successMsg = res['message'];
       },
       err => {
        this.errorMsg = err.error.error[0].message;
         this.appComponent.hideLoader();
         this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
         console.log(err);
         this.loading = false;
       }
     );
    } else if(this.registraionNo.length == 6) {
      this.getList();
    } else {
      this.errorMsg = 'Invalid Qr-Code!'
      this.loading = false;
    }

  }

  getList() {
    this.appComponent.showLoader();
    this.apiService.getDataFromServer(`/visitors?search=${this.registraionNo}`).subscribe(
      (res: any) => {
        this.registraionDetail = res && res.data && res.data.length ? res.data[0] : null;
        if(this.registraionDetail && this.registraionDetail.visitor_basic_details && Array.isArray(this.registraionDetail.visitor_basic_details)){
          for(let data of this.registraionDetail.visitor_basic_details){
            if(data.qrcode_scan && data.qrcode_scan.created_at){
              data.qrcode_scan.created_at = data.qrcode_scan && data.qrcode_scan.created_at ? moment.utc(data.qrcode_scan.created_at).local().format('DD-MM-YYYY HH:mm:ss') : '';
            }
          }
        }
        this.appComponent.hideLoader();
         this.loading = false;
      },
      err => {
        this.errorMsg = err.error.error[0].message;
         this.appComponent.hideLoader();
         this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
         this.loading = false;
      }
    );
  }

  verify() {
    this.registraionNo = '';
    this.errorMsg = '';
    this.textAreas.nativeElement.focus();
    this.visitorDetails = null;
    this.registraionDetail = null;
    this.successMsg = '';
  }

  public changeSearchValue(): void {
    this.successMsg = '';
    this.loading = true;
    this.visitorDetails = null;
    this.registraionDetail = null;
    this.errorMsg = '';
    this.idType = ''; // Reset ID type when search changes
    this.onChangeSearch.next();
  }

  public checkVerifyStatus() {
    if(this.registraionDetail && this.registraionDetail.visitor_basic_details){
     const isExist = this.registraionDetail.visitor_basic_details.find(res =>  !res.verify);
      if(isExist) {
        return true;
      } else {
        return false;
      }
      
    } else {
      return false;
    }
  }

}
